const modifySubmissionMaterial = function (
  { commit, dispatch },
  { id, field, value }
) {
  commit("UPDATE_MATERIAL", { id, field, value });
  dispatch("validateSubmission");
};

export default modifySubmissionMaterial;
